/**
 * bankMask — the browser's floor under I9 (corporate Business PAD contract,
 * 2026-10-25): a full account number leaves the API only toward the ACH
 * service, so every admin screen and XLSX export shows the last 4 at most.
 *
 * The API masks its responses too. This helper is applied wherever an account
 * number or IBAN is rendered or exported, so a response that still carries a
 * full number (an API older than the contract, a field it forgot) is masked
 * here anyway. It accepts a value the API already masked ("****1234") or a bare
 * last-4 field and returns the same "****1234".
 */

export const LAST4_MASK = "****";

const EMPTY = new Set(["", "null", "undefined"]);

/** "****1234" from any account number, IBAN, masked value or last-4; "" when there is none. */
export function maskAccount(value) {
  if (value === null || value === undefined) return "";
  const raw = String(value).trim();
  if (EMPTY.has(raw)) return "";
  // Only letters and digits count: spaces, dashes and an earlier mask do not.
  // The mask's own X or * characters are not account characters either.
  const chars = raw.replace(/^[*xX\s-]+/, "").replace(/[^0-9A-Za-z]/g, "");
  if (!chars) return "";
  return `${LAST4_MASK}${chars.slice(-4)}`;
}
